module.exports = __webpack_public_path__ + "static/media/check-white.909392f1.svg";